import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

export default function getGLTFModels(globeMaterials) {
    return new Promise((resolve, reject) => {
        new GLTFLoader().load('/resources/models/map.glb', ({ scene }) => {
            for (let i = 0; i < scene.children.length; i++) {
                const globe = scene.children[i]
                globe.receiveShadow = true
                globe.castShadow = false
                globe.material = globeMaterials[globe.name.slice(-1)]
                globe.material.depthWrite = false
            }

            resolve(scene)
        }, null, reject)
    })
}
